import { render, staticRenderFns } from "./cart-product-item-notification.vue?vue&type=template&id=4a148c5c&"
import script from "./cart-product-item-notification.vue?vue&type=script&lang=js&"
export * from "./cart-product-item-notification.vue?vue&type=script&lang=js&"
import style0 from "./cart-product-item-notification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports